import { render, staticRenderFns } from "./ContactData.vue?vue&type=template&id=e849b028&"
import script from "./ContactData.vue?vue&type=script&lang=js&"
export * from "./ContactData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContactData.vue"
export default component.exports